// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: N1x8b657r-z
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Email1 from "../../Email1"; // plasmic-import: MI5g4E25GS/component
import Password1 from "../../Password1"; // plasmic-import: lBJJS4mlxI/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 42T9zhO9Sy/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicLogin2.module.css"; // plasmic-import: N1x8b657r-z/css
import astrius4E16372055632166PngMunqEx9Jk from "./images/astrius4E16372055632166Png.png"; // plasmic-import: munqEX9JK/picture

createPlasmicElementProxy;

export const PlasmicLogin2__VariantProps = new Array();

export const PlasmicLogin2__ArgProps = new Array();

const $$ = {};

function PlasmicLogin2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <p.PlasmicImg
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"179px"}
            loading={"lazy"}
            src={{
              src: astrius4E16372055632166PngMunqEx9Jk,
              fullWidth: 289,
              fullHeight: 94,
              aspectRatio: undefined
            }}
          />

          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__qihFf
            )}
          >
            {"Welcome Back"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__stDmD
            )}
          >
            {"Login to your account"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__xIJr)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__tptxm
              )}
            >
              {"Email"}
            </div>
            <Email1
              data-plasmic-name={"loginEmailInput"}
              data-plasmic-override={overrides.loginEmailInput}
              className={classNames("__wab_instance", sty.loginEmailInput)}
            />

            <div
              data-plasmic-name={"invalidEmailText"}
              data-plasmic-override={overrides.invalidEmailText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.invalidEmailText
              )}
            >
              {"Invalid email address"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___7UZ7)}>
            <div className={classNames(projectcss.all, sty.freeBox__uvwsv)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__pnaiT
                )}
              >
                {"Password"}
              </div>
              <div
                data-plasmic-name={"forgotPassword"}
                data-plasmic-override={overrides.forgotPassword}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.forgotPassword
                )}
              >
                {"Forgot your password?"}
              </div>
            </div>
            <Password1
              data-plasmic-name={"loginPasswordInput"}
              data-plasmic-override={overrides.loginPasswordInput}
              className={classNames("__wab_instance", sty.loginPasswordInput)}
            />

            <div
              data-plasmic-name={"incorrectLoginText"}
              data-plasmic-override={overrides.incorrectLoginText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.incorrectLoginText
              )}
            >
              {"Incorrect email or password"}
            </div>
            <CustomErrorComponent
              data-plasmic-name={"customErrorInstance"}
              data-plasmic-override={overrides.customErrorInstance}
              className={classNames("__wab_instance", sty.customErrorInstance)}
              customErrorText={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__brOxh
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              }
            />
          </div>
          <div
            data-plasmic-name={"loginButton"}
            data-plasmic-override={overrides.loginButton}
            className={classNames(projectcss.all, sty.loginButton)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ro1CJ
              )}
            >
              {"Login"}
            </div>
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__bn88
            )}
          >
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#000000" }}
              >
                {"Don\u2019t have an account?"}
              </span>
              <React.Fragment>{"  "}</React.Fragment>
              {
                <span
                  data-plasmic-name={"signupText"}
                  data-plasmic-override={overrides.signupText}
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.signupText
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#3555FF" }}
                    >
                      {"Signup"}
                    </span>
                  </React.Fragment>
                </span>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "loginEmailInput",
    "invalidEmailText",
    "forgotPassword",
    "loginPasswordInput",
    "incorrectLoginText",
    "customErrorInstance",
    "loginButton",
    "signupText"
  ],

  img: ["img"],
  loginEmailInput: ["loginEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  forgotPassword: ["forgotPassword"],
  loginPasswordInput: ["loginPasswordInput"],
  incorrectLoginText: ["incorrectLoginText"],
  customErrorInstance: ["customErrorInstance"],
  loginButton: ["loginButton"],
  signupText: ["signupText"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogin2__ArgProps,
          internalVariantPropNames: PlasmicLogin2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogin2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogin2";
  } else {
    func.displayName = `PlasmicLogin2.${nodeName}`;
  }
  return func;
}

export const PlasmicLogin2 = Object.assign(
  // Top-level PlasmicLogin2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    loginEmailInput: makeNodeComponent("loginEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    forgotPassword: makeNodeComponent("forgotPassword"),
    loginPasswordInput: makeNodeComponent("loginPasswordInput"),
    incorrectLoginText: makeNodeComponent("incorrectLoginText"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    loginButton: makeNodeComponent("loginButton"),
    signupText: makeNodeComponent("signupText"),
    // Metadata about props expected for PlasmicLogin2
    internalVariantProps: PlasmicLogin2__VariantProps,
    internalArgProps: PlasmicLogin2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicLogin2;
/* prettier-ignore-end */
